module.exports = __webpack_public_path__ + "static/img/hbys-2.c9e0a106.jpg";